module.exports = __webpack_public_path__ + "static/media/green-arrow.1cc0f35e.svg";